import script from "./App.vue?vue&type=script&lang=ts&setup=true"
export * from "./App.vue?vue&type=script&lang=ts&setup=true"

import "./App.vue?vue&type=style&index=0&id=1bf5bb26&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/ClementRivaille.github.io/ClementRivaille.github.io/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bf5bb26"]])

export default __exports__